import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { DtoDocfilesGetReq } from "./abst/DtoDocfilesGetReq";
import { DtoApiPager } from "./abst/DtoApiPager";

export class DtoDocfilesGetReqImple extends DtoDocfilesGetReq {
  public pager = new DtoApiPager();

  public IsValidImple(chkPager: boolean): string[] {
    let res: string[] = new Array();
    //ページャー用入力値チェック
    if (chkPager) {
      this.pager.IsValid4Pager(res);
    } else {
      res = res.concat(super.IsValid());
    }

    return res;
  }
}
